export default __webpack_public_path__ + "static/navigation_b.cb566bcf5a4789e6a44e8f65e5f355df.svg";